import { AsyncPipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UserGroupAclStoreActions, UserGroupAclStoreSelectors, UserGroupStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { UserGroupAclMembers } from '@rocksoft/security-sdk';
import { AclPermissionDetailsComponent, isNotUndefined, NamedUserGroupAclGroups } from '@rocksoft/shared';
import { Observable } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
  selector: 'era-user-acl-permissions-details',
  templateUrl: './user-acl-permissions-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AclPermissionDetailsComponent, AsyncPipe],
})
export class UserAclPermissionsDetailsComponent {
  private readonly store = inject(Store);

  public readonly acl$: Observable<UserGroupAclMembers>;
  public readonly aclParents$: Observable<NamedUserGroupAclGroups[]>;

  constructor() {
    this.acl$ = this.store.select(UserGroupAclStoreSelectors.selectCurrentAclMember).pipe(filter(isNotUndefined));

    this.aclParents$ = this.store.select(UserGroupAclStoreSelectors.selectCurrentAclMember).pipe(
      filter(isNotUndefined),
      mergeMap((locationAclMember) =>
        this.store.select(UserGroupStoreSelectors.selectGroupIdsByParentId(locationAclMember.member)).pipe(
          mergeMap((groupIds: string[]) =>
            this.store.select(UserGroupAclStoreSelectors.selectCurrentAclGroupsWithNamesByGroupIds(groupIds)).pipe(
              filter(isNotUndefined),
              map((groups) => groups.map((g) => ({ ...g, name: g.name ?? '' })))
            )
          )
        )
      )
    );
  }

  public submitFormEvent(userGroupAclMembers: UserGroupAclMembers) {
    this.store.dispatch(
      UserGroupAclStoreActions.UserAclPermissionsUiActions.userGroupAclMemberPut({ aclMember: userGroupAclMembers })
    );
  }
}
